import React from 'react';
import { clsx } from '../utils/utils';
import * as styles from './Caption.module.scss';

export interface CaptionProps extends React.HTMLAttributes<HTMLDivElement> {
  small?: boolean;
  compact?: boolean;
}

const Caption = ({
  small,
  compact,
  className,
  children,
  ...restProps
}: CaptionProps): React.ReactElement => {
  return (
    <div
      className={clsx(
        styles.container,
        small && styles.small,
        compact && styles.compact,
        className,
      )}
      {...restProps}
    >
      <span className={styles.textContainer}>{children}</span>
    </div>
  );
};

export default Caption;
